export const MAX_PERCENTEGE = 100;
export const FALLBACK_IMAGE_PATH = './assets/images/no-image.svg';
export const SNACKBAR_DURATION = 4000;

export const SKIP_FOCUS_TRAP_ATTR = 'uw-dashboard-skip-focus-trap';

export const AUTOUNSUBSCRIBE_LISTENERS = 'AUTOUNSUBSCRIBE_LISTENERS';
export const SUBSCRIPTIONS = 'SUBSCRIPTIONS';

export const CUSTOM_SWITCH_TEAM_HEADER: string = 'X-Target-Account-Id';
